// Model exports
export {
  useJobQueueStore,
  type JobQueueStore,
  type QueueAggregate,
  isRenderJob,
  isAlbumJob,
  isUpscaleJob,
} from './model/job-queue.store';

// L1 reconcile adapter (WEB-L1) — service-layer fetch paths call this with
// JSON:API `included[]` to heal stale active jobs against the latest server
// state (both lost-completed and lost-started transitions).
export { reconcileRendersFromJsonApi } from './model/reconcile-from-json-api';

// Type exports
export type {
  Job,
  RenderJob,
  AlbumJob,
  UpscaleJob,
  ControlJob,
} from './model/job-queue.types';

// L4 watchdog hook (WEB-L4) — leader-tab 30s tick that probes overdue
// render/upscale jobs via `GET /renders/{id}` and heals via L1 / drops on 404.
export { useJobWatchdog } from './hooks/useJobWatchdog';

// Hook exports
export { useJobQueue } from './hooks/use-job-queue';
export {
  useQueueLimit,
  useRenderBlockReason,
  type QueueLimitStatus,
} from './hooks/use-queue-limit';
export {
  useActiveJobForConceptAngle,
  useActiveUpscaleForRender,
  useActiveUpscalesForRenders,
  useActiveJobForConcept,
  useLatestRenderForConceptAngle,
  useCompletedRenderFromStore,
  useCompletedRendersForAngles,
} from './hooks/use-job-queue';

// UI exports
export { JobQueueSheet } from './ui/JobQueueSheet';
